var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"clients"},[_c('v-title',{staticClass:"js-opacity",attrs:{"title":"Clients"}}),_c('ul',_vm._l((_vm.clients),function(client,i){return _c('v-client',{key:("client-" + i),attrs:{"client":client}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }